
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    ArrayField,
    SingleFieldList,
    EditButton,
    TextInput,
    DateInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    UrlField,
    SelectInput,
    Filter,
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Pagination,
    Button,
    ChipField,
    required,
    sanitizeListRestProps,
    SaveButton,
    DeleteButton,
    Toolbar,
    NumberInput,
    FileInput,
    FileField,
    translate,
    ImageField,
    ReferenceField,
    ReferenceInput,
    RichTextField,
    BooleanField,
    BooleanInput,
    AutocompleteInput,
    FunctionField,
} from 'react-admin'
import { cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'
import BookIcon from '@material-ui/icons/BookOutlined'
import RichTextInput from 'ra-input-rich-text';
import OptionalImageField from '../Customs/OptionalImageField'
import DuplicateButton from '../Customs/DuplicateButton'
import ClipboardButton from '../Customs/ClipboardButton'
import TinyInput from '../Customs/TinyInput'
import dataProvider from '../dataProvider'

export const CodeurPreResponseIcon = BookIcon

const CodeurPreResponse_Filter = (props) => (
    <Filter {...props}>
    </Filter>
)

const ListActions_Store = {}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props
    let {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext()
    ListActions_Store.filterValues = filterValues
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
        </TopToolbar>
    )
}

export const CodeurPreResponseList = (props) => (
    <List {...props} filters={<CodeurPreResponse_Filter />} actions={<ListActions />} perPage={10}>
        <Responsive
            small={
                <SimpleList linkType="show"
                    primaryText={record => record ? record.email : ''}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="title" />
                    <DateField source="createdAt" showTime={true} sortable={true} />
                    <DateField source="updatedAt" showTime={true} sortable={true} />
                    <ClipboardButton />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            }
        />
    </List>
)


export const CodeurPreResponseShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="title" />
            <RichTextField source="content" />
            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const CustomToolBar = props => <Toolbar {...props} ><SaveButton /></Toolbar>


export const CodeurPreResponseEdit = (props) => (
    <Edit {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} />
            <RichTextInput source="content" validate={required()} />
        </SimpleForm>
    </Edit>
)

export const CodeurPreResponseCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} />
            <RichTextInput source="content" validate={required()} />
        </SimpleForm>
    </Create>
)

